import { render, staticRenderFns } from "./ProjectPackage.vue?vue&type=template&id=3e7d99c1&scoped=true&"
import script from "./projectPackage.js?vue&type=script&lang=js&"
export * from "./projectPackage.js?vue&type=script&lang=js&"
import style0 from "./ProjectPackage.vue?vue&type=style&index=0&id=3e7d99c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7d99c1",
  null
  
)

export default component.exports